// s3Config.js
const getSlugName = () => {
  const { hostname } = window.location;
  return hostname?.split('.')?.[0];
};

const s3Config = (params) => {
  const slugName = params.slugName || getSlugName();
  return {
    DAM: `${slugName}/dam/`,
    DAM_VIDEO: `${slugName}/dam/video/`,
    PRODUCT_DAM_VIDEO: `${slugName}/product_dam/${params.devOrderId}/video/`,
    PRODUCT_DAM: `${slugName}/product_dam/${params.devOrderId}/`,
  };
};

export default s3Config;
